import React, { ReactNode } from "react";
import { Stack, Typography } from "@mui/material";

export interface InfoCardProps {
  icon?: string;
  heading?: string;
  content?: ReactNode;
  noPadding?: boolean;
  textColor?: "white" | "black" | "primary";
  bottomContent?: ReactNode;
}
const InfoCard = ({
  icon,
  heading,
  content,
  bottomContent,
  noPadding = false,
  textColor = "black",
}: InfoCardProps) => {
  return (
    <Stack
      pt={noPadding ? 0 : 3}
      px={noPadding ? 0 : 4}
      pb={noPadding ? 0 : 3}
      height="100%"
    >
      <Stack spacing={2} flex={1}>
        <Stack
          width="77px"
          height="77px"
          justifyContent="center"
          alignItems="center"
          className="background-primary"
          borderRadius="50%"
        >
          <i
            className={`${icon} font-white `}
            style={{ fontWeight: 500, fontSize: 28 }}
          />
        </Stack>
        <Typography
          variant="body1"
          fontWeight={700}
          className={`font-${textColor}`}
          textTransform="uppercase"
        >
          {heading}
        </Typography>
        <Stack height="190px" fontSize={16} lineHeight="25.6px">
          {content}
        </Stack>
      </Stack>
      {bottomContent && <Stack>{bottomContent}</Stack>}
    </Stack>
  );
};
export default InfoCard;
